import React from "react";  
import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";




export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-gray-50 to-gray-100 border-t border-gray-300 text-gray-800 font-['Roboto',sans-serif] pt-12">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 pb-10">
        
        {/* Customer Service */}
        <div>
          <h3 className="text-xl font-semibold mb-4 text-gray-800">
            Customer Service
          </h3>
          <ul className="space-y-2 text-sm text-gray-600">
            <li>
              <a href="/help" className="hover:text-gray-900 transition">
                Help Center
              </a>
            </li>
            <li>
              <a href="/returns" className="hover:text-gray-900 transition">
                Returns & Exchanges
              </a>
            </li>
            <li>
              <a href="/shipping" className="hover:text-gray-900 transition">
                Shipping Information
              </a>
            </li>
            <li>
              <a href="/privacy" className="hover:text-gray-900 transition">
                Privacy Policy
              </a>
            </li>
          </ul>
        </div>

        {/* Company Info */}
        <div>
          <h3 className="text-xl font-semibold mb-4 text-gray-800">
            Company
          </h3>
          <ul className="space-y-2 text-sm text-gray-600">
            <li>
              <a href="/about" className="hover:text-gray-900 transition">
                About Us
              </a>
            </li>
            <li>

             <Link to="/careers" className="hover:text-gray-900 transition">
              Careers
             </Link>
            </li>
            <li>
              <a href="/contact" className="hover:text-gray-900 transition">
                Contact Us
              </a>
            </li>
            <li>
              <a href="/terms" className="hover:text-gray-900 transition">
                Terms & Conditions
              </a>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-xl font-semibold mb-4 text-gray-800">
            Contact
          </h3>
          <ul className="space-y-3 text-sm text-gray-600">
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-gray-500" /> +91 98765 43210
            </li>
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-gray-500" /> support@smlnexgenllp.com
            </li>
            <li className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-gray-500" /> Hosūr, Tamil Nadu, India
            </li>
          </ul>
        </div>

        {/* Newsletter */}
        <div>
          <h3 className="text-xl font-semibold mb-4 text-gray-800">
            Join Our Newsletter
          </h3>
          <p className="text-sm text-gray-600 mb-3">
            Subscribe for updates on new arrivals, offers, and trends.
          </p>
          <div className="flex">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-gray-500"
            />
            <button className="bg-gray-800 hover:bg-gray-700 text-white px-4 rounded-r-md transition">
              Subscribe
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-300 py-4 flex flex-col sm:flex-row justify-between items-center text-sm text-gray-500 px-6">
        <p>© {new Date().getFullYear()} SML NEXGEN LLP — All Rights Reserved.</p>

        <div className="flex gap-3 mt-3 sm:mt-0">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg"
            alt="Visa"
            className="h-6 opacity-80 hover:opacity-100 transition"
          />
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg"
            alt="MasterCard"
            className="h-6 opacity-80 hover:opacity-100 transition"
          />
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg"
            alt="PayPal"
            className="h-6 opacity-80 hover:opacity-100 transition"
          />
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/5/5a/Google_Pay_%28GPay%29_Logo_%282018-2020%29.svg"
            alt="Google Pay"
            className="h-6 opacity-80 hover:opacity-100 transition"
          />
        </div>
      </div>
    </footer>
  );
}
